import { Availability, Product } from '@/types/cart';
import { isLocalSource } from './check-local-source';
import { Price } from '@/types/price';

export function getPrice(product: Product, availability: Availability, price: Price, t): Price | string {
  if (price?.listPrice === 0 || !price?.listPrice) {
    return t('contact.us');
  }

  if (product?.productStatus === 'BLOCKED' || product?.entitled === false || price?.priceStatus !== 'Orderable') {
    return t('contact.us');
  }
  if (product?.dwgFlag === 'Y' && availability?.totalStock === 0 && !isLocalSource(product?.localSource)) {
    return t('contact.us');
  }
  return price;
}
